<template>
  <div class="entry-player-box">
    <!-- 顶部：标题 + 更多操作（预留） -->
    <div class="title">
      <div class="title-left">
        <img src="https://images.snsports.cn/FnJ1snSwn9lMILUeyaZ2WUTxK9gL" alt="个人参赛表" class="title-logo" />
      </div>
    </div>

    <!-- 第一块：球队 + 赛事信息（参考截图样式） -->
    <div class="card card-full card-team-match">
      <div class="row row-team">
        <span class="label">球队</span>
        <div class="value team">
          <div class="team-logo" v-if="team.badge">
            <img :src="imageView(team.badge)" alt="" />
          </div>
          <span class="team-name">{{ team.name || '-' }}</span>
        </div>
      </div>
      <div class="row row-match">
        <span class="label">赛事</span>
        <div class="value match">
          <div class="match-line">
            <span class="match-name">{{ match.chineseName || match.unionMatchName || '-' }}</span>
          </div>
          <div class="match-sub">
            <span>{{ project.matchGroupName || match.group || '-' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 第二块：个人资料 -->
    <div class="card-section">
      <div class="card card-full card-player" @click="goPlayerDetail">
        <div class="card-player-left">
          <div class="card-player-title">
            <span class="title-text">个人资料</span>
          </div>
          <div class="player-main">
            <div class="avatar" v-if="player.avatar">
              <img :src="imageView(player.avatar)" alt="" />
            </div>
            <div class="info">
              <div class="name">{{ player.trueName || '-' }}</div>
            </div>
          </div>
        </div>
        <div class="card-link">查看详情</div>
      </div>

      <!-- 第三块：参赛费用（队员独立付费时显示：feeMethod === 1） -->
      <div v-if="match && match.isOpenCharge === 1 && match.feeMethod === 1" class="card-row">
        <div class="card card-half card-fee">
          <div class="card-title-row">
            <span class="card-title">参赛费用</span>
            <span class="card-link">{{ getPaymentStatus(player.orderStatus) }}</span>
          </div>
          <div class="card-desc">
            报名费：
            <span class="price">¥{{ feeAmountText }}</span>
          </div>
        </div>

        
      </div>
      <div class="card card-half card-survey" @click.stop="onNotOpenClick">
          <div class="card-title-row">
            <span class="card-title">答题/调研</span>
          </div>
          <div class="card-desc">进度：未开启</div>
        </div>

        <div class="card card-half card-agreement" @click.stop="onNotOpenClick">
          <div class="card-title-row">
            <span class="card-title">协议/声明</span>
          </div>
          <div class="card-desc">进度：未开启</div>
        </div>
    </div>

    <!-- 底部：删除按钮（样式与 player-info.vue 保持一致） -->
    <div class="bottom-actions" v-if="playerId">
      <div class="left" @click.stop="cancelPlayer">
        <div class="img">
          <img src="@/assets/images/delete-icon.png" alt="删除" />
        </div>
        <div>删除</div>
      </div>
      <div class="right-placeholder"></div>
    </div>
  </div>
</template>

<script>
import { getBMMatchTeamSignup, getBMMatchTeamPlayer, cancelBMMatchTeamPlayer } from '@/api/match'
import { QNImageUtil, DateUtil } from '@/utils'
import { orderStatusOptions } from '@/config'
import { Dialog, Toast } from 'vant'

export default {
  name: 'EntryInfoPlayer',
  data() {
    return {
      unionMatchId: '',
      matchId: '',
      teamId: '',
      playerId: '',
      match: {},
      project: {},
      team: {},
      player: {}
    }
  },
  computed: {
    /** 报名费：xx.xx/人 */
    feeAmountText() {
      if (!this.match || !this.match.feeAmount) return '0.00'
      const amount = (this.match.feeAmount / 100).toFixed(2)
      return amount
    },
    /** 个人资料是否完成（简单使用 orderStatus 是否已支付 或 registerStatus 完成） */
    playerCompleted() {
      const p = this.player || {}
      const orderStatus = p.orderStatus != null ? Number(p.orderStatus) : null
      if (orderStatus === 1 || orderStatus === 2) return true
      // 如果没有支付逻辑，则根据 registerStatus 简单判断
      if (p.registerStatus === 'FINISHED' || p.registerStatus === 'REVIEWED') return true
      return false
    }
  },
  mounted() {
    this.unionMatchId = this.$route.query.unionMatchId
    this.matchId = this.$route.query.matchId
    this.teamId = this.$route.query.teamId
    this.playerId = this.$route.query.playerId
    this.loadData()
  },
  methods: {
    onNotOpenClick() {
      Toast('暂未开启')
    },
    loadData() {
      const params = { matchId: this.matchId }
      if (this.teamId) params.teamId = this.teamId
      getBMMatchTeamSignup(params).then(res => {
        if (!res || !res.data) return
        const data = res.data
        this.match = data.match || {}
        this.project = data.match || {}
        this.team = data.team || {}
      })
      if (this.playerId) {
        getBMMatchTeamPlayer({ id: this.playerId }).then(res => {
          if (!res || !res.data) return
          const data = res.data
          this.player = data.player || {}
        })
      }
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getFormatDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{y}-{m}-{d}')
    },
    formatGender(gender) {
      if (gender === '1' || gender === 1) return '男'
      if (gender === '2' || gender === 2) return '女'
      return '不限'
    },
    getPaymentStatus(value) {
      const order = orderStatusOptions.find(o => o.value === value)
      return order?.label || '待支付'
    },
    goPlayerDetail() {
      this.$router.push(`/entry-page/player-info?teamId=${this.teamId}&matchId=${this.matchId}&unionMatchId=${this.unionMatchId}&playerId=${this.playerId || ''}&role=captain`)
    },
    // 取消球员报名（逻辑与 player-info.vue 保持一致）
    cancelPlayer() {
      const orderStatus = this.player && this.player.orderStatus
      if (orderStatus === 1 || orderStatus === 2) {
        Toast.fail('已支付报名费用，取消报名请联系组委会')
        return
      }
      Dialog.confirm({
        title: '提示',
        message: `是否确定要取消${this.player.trueName || ''}的报名吗？`,
      }).then(() => {
        const params = {
          matchId: this.matchId,
          teamId: this.teamId,
          playerId: this.playerId
        }
        cancelBMMatchTeamPlayer(params).then(res => {
          if (res) {
            Toast('取消成功')
            this.$router.back()
          }
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.entry-player-box {
  background: var(--bg2);
  min-height: 100vh;
  padding: 12px 14px 100px;
  box-sizing: border-box;

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title-left {
      display: flex;
      align-items: center;
      .title-logo {
        width: 95px;
        height: 22px;
        display: block;
      }
      .title-text {
        margin-left: 8px;
        font-size: 14px;
        font-weight: bold;
        color: #3D3D3D;
      }
    }
  }

  .card {
    background: #fff;
    border-radius: 8px;
    padding: 14px 16px;
    // margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .card-team-match {
    flex-direction: column;
    align-items: stretch;
    border: 1px solid #DEDEDE;
    .row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      font-size: 13px;
      color: #666;
      & + .row {
        margin-top: 6px;
      }
      .label {
        flex-shrink: 0;
        min-width: 40px;
        font-size: 14px;
        font-weight: bold;
        color: #3D3D3D;
      }
      .value {
        // flex: 1;
        font-size: 15px;
        min-width: 0;
      }
      .team {
        display: flex;
        align-items: center;
        .team-logo {
          width: 25px;
          height: 25px;
          overflow: hidden;
          background: #e8e8e8;
          margin-right: 8px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .match-line {
        font-size: 14px;
        color: #1d2129;
      }
      .match-sub {
        text-align: right;
        font-size: 12px;
        color: #999;
        margin-top: 8px;
      }
    }
    .row-team {
      align-items: center;
    }
    .row-match {
      margin-top: 12px !important;
    }
  }

  .card-section {
    margin-top: 12px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .card{
      background-color: var(--bg1);
    }
    .card-row{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      gap: 12px;
      margin-top: 12px;
    }
    /* 和 entry-info.vue 保持一致的半卡片尺寸与布局 */
    .card-half{
      width: 167px;
      height: 105px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
    }
    .card-title-row{
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .card-title{
        margin-bottom: 0;
        font-size: 15px;
        font-weight: 500;
        color: #1d2129;
      }
      .card-link{
        flex-shrink: 0;
        margin-left: 8px;
        font-size: 14px;
        color: #1989fa;
      }
    }
    .card-player {
      margin-bottom: 12px;
      width: 100%;

      .card-player-left {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        .card-player-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
          .title-text {
            font-size: 15px;
            font-weight: 500;
            color: #1d2129;
          }
        }
        .player-main {
          display: flex;
          align-items: center;
        }
        .avatar {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          overflow: hidden;
          background: #e8e8e8;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .info {
          margin-left: 12px;
          .name {
            font-size: 15px;
            font-weight: 500;
            color: #1d2129;
          }
        }
      }
      .card-link {
        font-size: 14px;
        color: #1989fa;
        flex-shrink: 0;
      }
    }

    .card-fee {
      flex-direction: column;
      align-items: stretch;
      .card-desc {
        margin-top: 6px;
        font-size: 13px;
        color: #666;
        .price {
          font-size: 15px;
          font-weight: 500;
          color: #1d2129;
        }
      }
    }

    .card-survey,
    .card-agreement {
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
      .card-desc {
        margin-top: 12px;
        font-size: 13px;
        color: #666;
      }
    }
  }

  /* 底部操作区：删除按钮样式与 player-info.vue 保持一致 */
  .bottom-actions {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 12px 16px;
    background-color: #ffffff;
    border-top: 0.5px solid #eeeeee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      font-size: 11px;
      color: #3d3d3d;
      text-align: center;
      .img {
        width: 27px;
        height: 27px;
        background: #e3f1ff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 3px;
        img {
          width: 14px;
          height: 14px;
        }
      }
    }
    .right-placeholder {
      width: 111px;
      height: 37px;
    }
  }
}
</style>

